import {ATENCIONSELECT} from '../types';

export const atenCionSelectAction = ( data ) => async (dispatch) =>{

    dispatch({
        type: ATENCIONSELECT,
        payload: data
    });

}